import { combineReducers } from "@reduxjs/toolkit";
import { slice } from "./slices/app";
import { contacts } from "./slices/contacts";

export const rootReducer = combineReducers({
  app: slice.reducer,
  contacts: contacts.reducer,
});
